import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import PageHeader from '../../components/layout/PageHeader';
import Table from '../../components/ui/Table';
import Badge from '../../components/ui/Badge';
import Button from '../../components/ui/Button';
import { REASON_LABELS } from '../../components/leads/VerifyLeadModal';
import RejectedItemUpdateModal from '../../components/leads/RejectedItemUpdateModal';
import { listRejectedApplicants } from '../../api/leads';

/** Applicants a verifier rejected items on — what to fix and why. Scoped to the user's own leads unless they can view all. */
export default function RejectedApplicants() {
  const [page, setPage] = useState(1);
  const [updating, setUpdating] = useState(null); // the row being updated
  const query = useQuery({
    queryKey: ['rejected-applicants', page],
    queryFn: () => listRejectedApplicants({ page }),
  });

  const columns = [
    {
      key: 'reference_no',
      label: 'Reference No',
      render: (row) => (
        <Link to={`/leads/${row.id}`} className="font-medium text-primary hover:underline">
          {row.reference_no}
        </Link>
      ),
    },
    { key: 'full_name', label: 'Full Name' },
    { key: 'contact_no', label: 'Contact No' },
    { key: 'created_by', label: 'Added By' },
    {
      key: 'actions',
      label: '',
      render: (row) => (
        <Button className="px-3 py-1.5 text-xs" onClick={() => setUpdating(row)}>
          Update ({row.rejected_items.length})
        </Button>
      ),
    },
    {
      key: 'rejected_items',
      label: 'Rejected fields / documents',
      render: (row) => (
        <ul className="space-y-1.5">
          {row.rejected_items.map((item) => (
            <li key={`${item.type}:${item.key}`} className="text-sm">
              <span className="font-medium text-gray-900">{item.label}</span>{' '}
              <Badge tone="gray">{item.type}</Badge>{' '}
              <Badge tone="red">{REASON_LABELS[item.reason] || item.reason}</Badge>
              {item.remark && <div className="text-xs text-gray-500">“{item.remark}”</div>}
              <div className="text-xs text-gray-400">
                {item.reviewed_by ? `by ${item.reviewed_by}` : ''}
                {item.reviewed_at ? ` · ${new Date(item.reviewed_at).toLocaleString()}` : ''}
              </div>

            </li>
          ))}
        </ul>
      ),
    },
  ];

  return (
    <div>
      <PageHeader title="Rejected Applicants" description="Applicants whose verification was rejected. Fix the listed fields or documents on the applicant's page and it goes back for verification." />
      <RejectedItemUpdateModal leadId={updating?.id} items={updating?.rejected_items} onClose={() => setUpdating(null)} />
      <Table
        columns={columns}
        data={query.data?.data || []}
        isLoading={query.isLoading}
        pagination={query.data}
        onPageChange={setPage}
        emptyMessage="No rejected applicants."
      />
    </div>
  );
}
